<script>

    import {createEventDispatcher} from "svelte";
    import {t} from "../core/i18n/language-store.js";
    const dispatch = createEventDispatcher();

    export let mod = undefined;
    export let currency = undefined;

    function selectHandler(option) {

        mod.options.forEach(x => {

            if (mod.type === 'single') {
                x.selected = x === option;
            }

            if (mod.type === 'multiple' && x === option) {
                x.selected = !x.selected;
            }
        });

        mod = {...mod};

        dispatch('changed', {mod});
    }

</script>

<style>
    .pb-05 {
        padding-bottom: .5rem;
    }
    strong {
        font-weight: 400;
        font-family: Roboto Condensed, sans-serif;
        text-transform: uppercase;
    }

    .opts li {
        font-weight: 300;
        font-family: Roboto Condensed, sans-serif;
        padding: .4rem 0;
        color: var(--main-font-color);
        transition: color .2s ease;
    }
    .opts li.option--selected {
        color: var(--accent-color);
    }

    svg.selected {
        display: none;
    }
    svg.unselected {
        display: inline-block;
    }

    .option--selected {

    }
    .option--selected svg.selected {
        display: inline-block;
    }
    .option--selected svg.unselected {
        display: none;
    }
    .option--out-of-stock {
        opacity: .5;
        pointer-events: none;
    }
</style>

<div class="mod-selector">

    <div class="pb-05">
        <strong class="mod-name">{ mod.name }</strong>
    </div>

    <ul class="opts">
        {#each mod.options as option}
        <li class="mod flex-between"
            class:option--selected={option.selected}
            class:option--out-of-stock={option.outOfStock}
            on:click={() => selectHandler(option)}>
            <div class="flex ai-center gap-05 lh-1">

                {#if (mod.type === 'single')}
                    <svg class="selected" width="1em" height="1em" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <circle cx="6" cy="6" r="5.5" fill="currentColor" stroke="currentColor"/>
                        <path d="M3 5L5.5 8.5L9.5 3.5" stroke="black" stroke-linejoin="round"/>
                    </svg>

                    <svg class="unselected" width="1em" height="1em" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <circle cx="6" cy="6" r="5.5" stroke="currentColor"/>
                    </svg>
                {/if}

                {#if (mod.type === 'multiple')}
                    <svg class="selected" width="1em" height="1em" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <rect x="0" y="0" width="12" height="12" rx="1.5" fill="currentColor"/>
                        <path d="M3 5L5.5 8.5L9.5 3.5" stroke="black" stroke-linejoin="round"/>
                    </svg>

                    <svg class="unselected" width="1em" height="1em" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <rect x="0.5" y="0.5" width="11" height="11" rx="1.5" stroke="currentColor"/>
                    </svg>
                {/if}

                <span>
                    { option.name }
                </span>

                {#if (option.outOfStock)}
                    <span> ({$t('modSelector.outOfStock')})</span>
                {/if}

            </div>
            <div class="fs-90">
                {#if (option.priceMod !== undefined)}
                    {#if (option.priceMod > 0)}+{/if}
                    <span class="price-pair" class:price-pair--rev={currency === '$'}>
                        <span>{ option.priceMod || '' }</span>
                        {#if (option.priceMod)}
                        <span>{ currency || '' }</span>
                        {/if}
                    </span>
                {/if}
            </div>
        </li>
        {/each}
    </ul>

</div>
